<!-- HEADER -->
<div class="modal-header">
  <h5 class="w-100 mb-0">
    <div class="d-flex justify-content-between align-items-center">
      <div class="ps-4">
        <span class="entity-label">{{ riskMatrixDialogData?.entityLabel }}</span>
      </div>

      <div class="d-flex gap-2 align-items-center">
        <button mat-stroked-button (click)="onExport()">
          <mat-icon>download</mat-icon>
          {{ 'map.sidebar.psa.bulk_risk_matrix.export' | translate }}
        </button>

        <button mat-stroked-button (click)="onSendToDocuments()">
          <mat-icon>inventory</mat-icon>
          {{ 'map.sidebar.psa.actions.matrice_rischio.download_filesystem' | translate }}
        </button>

        <button mat-stroked-button (click)="onDuplicate()">
          <mat-icon>content_copy</mat-icon>
          {{ 'map.sidebar.psa.actions.matrice_rischio.duplicate' | translate }}
        </button>

        <button mat-raised-button color="primary" (click)="addNewEvent()">
          <mat-icon>add</mat-icon>
          {{ 'map.sidebar.psa.bulk_risk_matrix.new_event' | translate }}
        </button>
      </div>
    </div>
  </h5>
</div>

<!-- BODY -->
<div class="modal-body px-0">

  <!-- TOOLBAR -->
  <div class="toolbar d-flex align-items-center justify-content-end gap-2 flex-wrap px-3 py-2">
    <button mat-stroked-button [disabled]="isExpandingAll || isCollapsingAll || isAllExpanded" (click)="expandAll()">
      <mat-icon>unfold_more</mat-icon>
      {{ 'map.sidebar.psa.bulk_risk_matrix.expand_all' | translate }}
    </button>
    <button mat-stroked-button [disabled]="isExpandingAll || isCollapsingAll || isAllCollapsed" (click)="collapseAll()">
      <mat-icon>unfold_less</mat-icon>
      {{ 'map.sidebar.psa.bulk_risk_matrix.collapse_all' | translate }}
    </button>
    <button mat-stroked-button (click)="cancelChanges()">
      <mat-icon>undo</mat-icon>
      {{ 'map.sidebar.psa.bulk_risk_matrix.cancel_changes' | translate }}
    </button>
    <button mat-stroked-button (click)="clearFilters()">
      <mat-icon>filter_list_off</mat-icon>
      {{ 'map.sidebar.psa.bulk_risk_matrix.clear_filters' | translate }}
    </button>
  </div>

  <!-- BULK ACTIONS BAR — visibile solo con eventi selezionati (Test Case 7 HLD) -->
  <div *ngIf="selectedEvents.hasValue()" class="bulk-actions-bar d-flex align-items-center gap-2 flex-wrap px-3 py-2">
    <span class="bulk-label">
      {{ selectedEvents.selected.length }} {{ 'map.sidebar.psa.bulk_risk_matrix.selected_count' | translate }}
    </span>

    <button mat-stroked-button (click)="bulkActivate()">
      <mat-icon>check_circle</mat-icon>
      {{ 'map.sidebar.psa.bulk_risk_matrix.activate' | translate }}
    </button>

    <button mat-stroked-button (click)="bulkDeactivate()">
      <mat-icon>remove_circle_outline</mat-icon>
      {{ 'map.sidebar.psa.bulk_risk_matrix.deactivate' | translate }}
    </button>

    <mat-form-field appearance="outline" class="inline-field bulk-gravity-field">
      <mat-select [(ngModel)]="bulkGravity" panelClass="risk-matrix-select-panel"
        placeholder="{{ 'map.sidebar.psa.bulk_risk_matrix.col_gravity' | translate }}">
        <mat-option *ngFor="let g of bulkGravityOptions" [value]="g">{{ g }}</mat-option>
      </mat-select>
    </mat-form-field>
    <button mat-stroked-button [disabled]="bulkGravity == null" (click)="bulkApplyGravity()">
      {{ 'map.sidebar.psa.bulk_risk_matrix.apply' | translate }}
    </button>

    <button mat-stroked-button color="warn" (click)="bulkDelete()">
      <mat-icon>delete_outline</mat-icon>
      {{ 'map.sidebar.psa.bulk_risk_matrix.delete' | translate }}
    </button>
  </div>

  <!-- LOADING -->
  <div *ngIf="isLoading" class="d-flex justify-content-center py-5">
    <mat-spinner diameter="36"></mat-spinner>
  </div>

  <!-- ================================================================
       MAT-TABLE — multiTemplateDataRows
       Row 1: riga evento principale
       Row 2: detail row azioni mitigatrici (collassabile con @detailExpand)
       ================================================================ -->
  <div class="table-container" *ngIf="!isLoading">

    <!-- Overlay globale durante espandi/riduci tutto: il lavoro è sincrono e
         pesante (istanzia/distrugge tutte le detail-row filtrate in un colpo
         solo), quindi oscuriamo l'intera tabella per non far sembrare
         l'interfaccia bloccata — nessuno spinner, solo l'oscuramento. -->
    <div class="bulk-expand-overlay" *ngIf="isExpandingAll || isCollapsingAll"></div>

    <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="risk-matrix-table w-100">

      <!-- ================= COLONNE PRINCIPALI ================= -->

      <!-- Selezione multipla (Test Case 7 HLD) -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef class="col-select">
          <mat-checkbox color="primary" [checked]="isAllPagedSelected()" (change)="toggleSelectAllPaged()"
            (click)="$event.stopPropagation()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let event" class="col-select">
          <mat-checkbox color="primary" [checked]="selectedEvents.isSelected(event)"
            (change)="selectedEvents.toggle(event)" (click)="$event.stopPropagation()">
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- Chevron expand -->
      <ng-container matColumnDef="expand">
        <th mat-header-cell *matHeaderCellDef class="col-expand"></th>
        <td mat-cell *matCellDef="let event" class="col-expand">
          <button mat-icon-button class="expand-btn" (click)="toggleExpand(event); $event.stopPropagation()">
            <mat-icon>
              {{ isExpanded(event) ? 'expand_more' : 'chevron_right' }}
            </mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- Attivo (checkbox) -->
      <ng-container matColumnDef="active">
        <th mat-header-cell *matHeaderCellDef class="col-active">
          {{ 'map.sidebar.psa.bulk_risk_matrix.col_active' | translate }}
        </th>
        <td mat-cell *matCellDef="let event" class="col-active">
          <mat-checkbox color="primary" [(ngModel)]="event.attivo" [disabled]="isEventLocked(event)"
            [matTooltip]="isEventLocked(event) ? ('map.sidebar.psa.risk_event.cannot_set_as_not_active' | translate) : ''"
            (click)="$event.stopPropagation()">
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- Lavorato (icona toggle, recuperata dal vecchio accordion collassabile) -->
      <ng-container matColumnDef="worked">
        <th mat-header-cell *matHeaderCellDef class="col-worked">
          {{ 'map.sidebar.psa.risk_event.worked' | translate }}
        </th>
        <td mat-cell *matCellDef="let event" class="col-worked">
          <!-- Il tooltip va sullo span, non sul button: un button [disabled] blocca
               gli eventi del puntatore e matTooltip non si attiverebbe mai in hover. -->
          <span
            [matTooltip]="(event.lavorato ? 'map.sidebar.psa.risk_event.unset_as_worked' : (canToggleWorked(event) ? 'map.sidebar.psa.risk_event.set_as_worked' : 'map.sidebar.psa.risk_event.cannot_set_as_worked')) | translate">
            <button mat-icon-button [disabled]="!canToggleWorked(event)"
              (click)="toggleWorked(event); $event.stopPropagation()">
              <mat-icon [color]="event.lavorato ? 'primary' : ''">{{ event.lavorato ? 'work' : 'work_off' }}</mat-icon>
            </button>
          </span>
        </td>
      </ng-container>

      <!-- Tipo di pericolo (icone recuperate dal vecchio accordion collassabile) -->
      <ng-container matColumnDef="hazards">
        <th mat-header-cell *matHeaderCellDef class="col-hazards">
          {{ 'map.sidebar.psa.bulk_risk_matrix.col_hazards' | translate }}
        </th>
        <td mat-cell *matCellDef="let event" class="col-hazards">
          <!-- Prima erano icone di sola lettura, mostrate solo se il pericolo era già
               true: un evento nuovo nasceva con tutti e 4 fissi a false e non c'era
               alcun modo di attivarli. Ora sono sempre visibili e cliccabili (tranne
               che su un evento lavorato, dove nessuna modifica è permessa). -->
          <div class="indicators" [class.indicators-locked]="isEventLocked(event)">
            <mat-icon svgIcon="pericolo_biologico" class="indicator-icon toggle-icon"
              [class.indicator-off]="!event.evento.pericolo_biologico"
              [matTooltip]="'map.sidebar.psa.risk_event.pericolo_biologico' | translate"
              (click)="toggleHazard(event, 'pericolo_biologico'); $event.stopPropagation()"></mat-icon>
            <mat-icon svgIcon="pericolo_chimico" class="indicator-icon toggle-icon"
              [class.indicator-off]="!event.evento.pericolo_chimico"
              [matTooltip]="'map.sidebar.psa.risk_event.pericolo_chimico' | translate"
              (click)="toggleHazard(event, 'pericolo_chimico'); $event.stopPropagation()"></mat-icon>
            <mat-icon svgIcon="pericolo_fisico" class="indicator-icon toggle-icon"
              [class.indicator-off]="!event.evento.pericolo_fisico"
              [matTooltip]="'map.sidebar.psa.risk_event.pericolo_fisico' | translate"
              (click)="toggleHazard(event, 'pericolo_fisico'); $event.stopPropagation()"></mat-icon>
            <mat-icon svgIcon="pericolo_quantitativo" class="indicator-icon toggle-icon"
              [class.indicator-off]="!event.evento.pericolo_quantitativo"
              [matTooltip]="'map.sidebar.psa.risk_event.pericolo_quantitativo' | translate"
              (click)="toggleHazard(event, 'pericolo_quantitativo'); $event.stopPropagation()"></mat-icon>
          </div>
        </td>
      </ng-container>

      <!-- Nome evento -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="col-name">
          {{ 'map.sidebar.psa.bulk_risk_matrix.col_name' | translate }}
        </th>
        <td mat-cell *matCellDef="let event" class="col-name">
          <mat-form-field appearance="outline" class="inline-field wrap-field w-100">
            <textarea matInput rows="2" [(ngModel)]="event.evento.nome" placeholder="Nome evento"
              [matTooltip]="event.evento.nome" matTooltipShowDelay="400" matTooltipPosition="above"
              [disabled]="isEventLocked(event)" (click)="$event.stopPropagation()"></textarea>
          </mat-form-field>
        </td>
      </ng-container>

      <!-- Descrizione evento -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef class="col-desc">
          {{ 'map.sidebar.psa.bulk_risk_matrix.col_description' | translate }}
        </th>
        <td mat-cell *matCellDef="let event" class="col-desc">
          <mat-form-field appearance="outline" class="inline-field wrap-field w-100">
            <textarea matInput rows="2" [(ngModel)]="event.evento.descrizione" placeholder="Descrizione"
              [matTooltip]="event.evento.descrizione" matTooltipShowDelay="400" matTooltipPosition="above"
              [disabled]="isEventLocked(event)" (click)="$event.stopPropagation()"></textarea>
          </mat-form-field>
        </td>
      </ng-container>

      <!-- Probabilità -->
      <ng-container matColumnDef="probability">
        <th mat-header-cell *matHeaderCellDef class="col-probability">
          {{ 'map.sidebar.psa.bulk_risk_matrix.col_probability' | translate }}
        </th>
        <td mat-cell *matCellDef="let event" class="col-probability">
          <mat-form-field appearance="outline" class="inline-field gravity-field w-100">
            <input matInput [(ngModel)]="event.probabilita" type="number" min="1" max="5" pattern="[0-9]*" placeholder="–"
              [disabled]="isEventLocked(event)" (click)="$event.stopPropagation()">
          </mat-form-field>
        </td>
      </ng-container>

      <!-- Gravità -->
      <ng-container matColumnDef="gravity">
        <th mat-header-cell *matHeaderCellDef class="col-gravity">
          {{ 'map.sidebar.psa.bulk_risk_matrix.col_gravity' | translate }}
        </th>
        <td mat-cell *matCellDef="let event" class="col-gravity">
          <mat-form-field appearance="outline" class="inline-field gravity-field w-100">
            <input matInput [(ngModel)]="event.evento.gravita" type="number" min="1" max="5" pattern="[0-9]*" placeholder="–"
              [required]="!!event._isNew" [disabled]="isEventLocked(event)" (click)="$event.stopPropagation()">
          </mat-form-field>
        </td>
      </ng-container>

      <!-- Azioni riga -->
      <ng-container matColumnDef="rowActions">
        <th mat-header-cell *matHeaderCellDef class="col-row-actions"></th>
        <td mat-cell *matCellDef="let event" class="col-row-actions">
          <button mat-icon-button color="warn" (click)="deleteEvent(event, $event)"
            matTooltip="{{ 'map.sidebar.psa.bulk_risk_matrix.tooltip_delete_event' | translate }}">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- ================= FILTER ROW (header secondario) ================= -->

      <ng-container matColumnDef="filter-select">
        <th mat-header-cell *matHeaderCellDef class="col-select filter-cell"></th>
      </ng-container>

      <ng-container matColumnDef="filter-expand">
        <th mat-header-cell *matHeaderCellDef class="col-expand filter-cell"></th>
      </ng-container>

      <ng-container matColumnDef="filter-worked">
        <th mat-header-cell *matHeaderCellDef class="col-worked filter-cell">
          <mat-form-field appearance="outline" class="filter-field w-100">
            <mat-select [(ngModel)]="filterWorked" (ngModelChange)="applyFilter()"
              panelClass="risk-matrix-select-panel"
              placeholder="{{ 'map.sidebar.psa.bulk_risk_matrix.filter_all' | translate }}">
              <mat-option [value]="null">{{ 'map.sidebar.psa.bulk_risk_matrix.filter_all' | translate }}</mat-option>
              <mat-option [value]="true">{{ 'map.sidebar.psa.risk_event.worked' | translate }}</mat-option>
              <mat-option [value]="false">{{ 'map.sidebar.psa.risk_event.not_worked' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </th>
      </ng-container>

      <ng-container matColumnDef="filter-hazards">
        <th mat-header-cell *matHeaderCellDef class="col-hazards filter-cell"></th>
      </ng-container>

      <ng-container matColumnDef="filter-active">
        <th mat-header-cell *matHeaderCellDef class="col-active filter-cell">
          <mat-form-field appearance="outline" class="filter-field w-100">
            <mat-select [(ngModel)]="filterActive" (ngModelChange)="applyFilter()"
              panelClass="risk-matrix-select-panel"
              placeholder="{{ 'map.sidebar.psa.bulk_risk_matrix.filter_all' | translate }}">
              <mat-option [value]="null">{{ 'map.sidebar.psa.bulk_risk_matrix.filter_all' | translate }}</mat-option>
              <mat-option [value]="true">{{ 'map.sidebar.psa.bulk_risk_matrix.filter_active_true' | translate }}</mat-option>
              <mat-option [value]="false">{{ 'map.sidebar.psa.bulk_risk_matrix.filter_active_false' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </th>
      </ng-container>

      <ng-container matColumnDef="filter-name">
        <th mat-header-cell *matHeaderCellDef class="col-name filter-cell">
          <mat-form-field appearance="outline" class="filter-field w-100">
            <input matInput [(ngModel)]="filterName" (ngModelChange)="onFilterChange()"
              placeholder="{{ 'map.sidebar.psa.bulk_risk_matrix.filter_name' | translate }}">
            <mat-icon matSuffix *ngIf="filterName" class="clear-icon" (click)="filterName=''; applyFilter()">close
            </mat-icon>
          </mat-form-field>
        </th>
      </ng-container>

      <ng-container matColumnDef="filter-description">
        <th mat-header-cell *matHeaderCellDef class="col-desc filter-cell">
          <mat-form-field appearance="outline" class="filter-field w-100">
            <input matInput [(ngModel)]="filterDescription" (ngModelChange)="onFilterChange()"
              placeholder="{{ 'map.sidebar.psa.bulk_risk_matrix.filter_desc' | translate }}">
            <mat-icon matSuffix *ngIf="filterDescription" class="clear-icon"
              (click)="filterDescription=''; applyFilter()">close
            </mat-icon>
          </mat-form-field>
        </th>
      </ng-container>

      <ng-container matColumnDef="filter-probability">
        <th mat-header-cell *matHeaderCellDef class="col-probability filter-cell">
          <mat-form-field appearance="outline" class="filter-field w-100">
            <mat-select [(ngModel)]="filterProbability" (ngModelChange)="applyFilter()"
              panelClass="risk-matrix-select-panel"
              placeholder="{{ 'map.sidebar.psa.bulk_risk_matrix.filter_all' | translate }}">
              <mat-option [value]="null">{{ 'map.sidebar.psa.bulk_risk_matrix.filter_all' | translate }}</mat-option>
              <mat-option [value]="notEvaluatedFilter">{{ 'map.sidebar.psa.bulk_risk_matrix.filter_not_evaluated' | translate }}</mat-option>
              <mat-option *ngFor="let p of probabilityOptions" [value]="p">{{ p }}</mat-option>
            </mat-select>
          </mat-form-field>
        </th>
      </ng-container>

      <ng-container matColumnDef="filter-gravity">
        <th mat-header-cell *matHeaderCellDef class="col-gravity filter-cell">
          <mat-form-field appearance="outline" class="filter-field w-100">
            <mat-select [(ngModel)]="filterGravity" (ngModelChange)="applyFilter()"
              panelClass="risk-matrix-select-panel"
              placeholder="{{ 'map.sidebar.psa.bulk_risk_matrix.filter_all' | translate }}">
              <mat-option [value]="null">{{ 'map.sidebar.psa.bulk_risk_matrix.filter_all' | translate }}</mat-option>
              <mat-option [value]="notEvaluatedFilter">{{ 'map.sidebar.psa.bulk_risk_matrix.filter_not_evaluated' | translate }}</mat-option>
              <mat-option *ngFor="let g of gravityOptions" [value]="g">{{ g }}</mat-option>
            </mat-select>
          </mat-form-field>
        </th>
      </ng-container>

      <ng-container matColumnDef="filter-rowActions">
        <th mat-header-cell *matHeaderCellDef class="col-row-actions filter-cell"></th>
      </ng-container>

      <!-- ================= DETAIL ROW — Azioni Mitigatrici ================= -->

      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let event" [attr.colspan]="displayedColumns.length" class="detail-cell">

          <div class="detail-wrapper" [@detailExpand]="isExpanded(event) ? 'expanded' : 'collapsed'">

            <!-- Contenuto istanziato solo alla prima espansione: con multiTemplateDataRows
                 questa detail-row esiste per OGNI riga evento fin dal render iniziale — senza
                 questo *ngIf, la sotto-tabella (fino a 8 mat-form-field outline per azione,
                 con le loro misurazioni sincrone di layout) verrebbe costruita per tutti gli
                 eventi già alla prima apertura del dialog, anche per quelli mai espansi. -->
            <ng-container *ngIf="isExpanded(event)">
              <!-- Header sezione azioni mitigatrici -->
              <div class="mitigation-header d-flex align-items-center gap-2 px-3 py-1">
                <mat-icon class="section-icon">shield</mat-icon>
                <span class="section-title">
                  {{ 'map.sidebar.psa.bulk_risk_matrix.mitigation_actions' | translate }}
                </span>
                <button *ngIf="!isEventLocked(event)" mat-icon-button class="add-action-btn"
                  (click)="addMitigationAction(event, $event)"
                  matTooltip="{{ 'map.sidebar.psa.bulk_risk_matrix.add_action' | translate }}">
                  <mat-icon>add_circle_outline</mat-icon>
                </button>
              </div>

              <!-- Empty state azioni -->
              <p *ngIf="!event.actions || event.actions.length === 0" class="no-actions-label px-4 py-2 mb-0">
                {{ 'map.sidebar.psa.bulk_risk_matrix.no_actions' | translate }}
              </p>

              <!-- Sotto-tabella azioni mitigatrici -->
              <div class="mitigation-scroll" *ngIf="event.actions?.length > 0">
                <table mat-table [dataSource]="event.actions" class="mitigation-table w-100">

                <!-- Stato -->
                <ng-container matColumnDef="mit_status">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ 'map.sidebar.psa.bulk_risk_matrix.col_status' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let action">
                    <!-- tooltip sul campo e sulle voci, non solo sull'icona -->
                    <mat-form-field appearance="outline" class="inline-field mit-status-field"
                      [matTooltip]="getStatoTooltipKey(action.stato) | translate">
                      <mat-select [(ngModel)]="action.stato" [disabled]="isEventLocked(event)" panelClass="risk-matrix-select-panel">
                        <mat-select-trigger>
                          <mat-icon [color]="getStatoColor(action.stato)">
                            {{ getStatoIcon(action.stato) }}
                          </mat-icon>
                        </mat-select-trigger>
                        <mat-option [value]="0" [matTooltip]="getStatoTooltipKey(0) | translate">
                          <mat-icon [color]="getStatoOptionColor(0, action.stato)">{{ getStatoIcon(0) }}</mat-icon>
                        </mat-option>
                        <mat-option [value]="1" [matTooltip]="getStatoTooltipKey(1) | translate">
                          <mat-icon [color]="getStatoOptionColor(1, action.stato)">{{ getStatoIcon(1) }}</mat-icon>
                        </mat-option>
                        <mat-option [value]="2" [matTooltip]="getStatoTooltipKey(2) | translate">
                          <mat-icon [color]="getStatoOptionColor(2, action.stato)">{{ getStatoIcon(2) }}</mat-icon>
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </td>
                </ng-container>

                <!-- Nome azione -->
                <ng-container matColumnDef="mit_name">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ 'map.sidebar.psa.bulk_risk_matrix.col_name' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let action">
                    <mat-form-field appearance="outline" class="inline-field wrap-field w-100">
                      <!-- il nome di un'azione già salvata non è modificabile: è condiviso dal catalogo -->
                      <textarea matInput rows="2" [(ngModel)]="action.azione.nome" placeholder="Nome azione"
                        [matTooltip]="action.azione.nome" matTooltipShowDelay="400" matTooltipPosition="above"
                        [disabled]="isEventLocked(event) || !action._isNew"></textarea>
                    </mat-form-field>
                  </td>
                </ng-container>

                <!-- Descrizione azione -->
                <ng-container matColumnDef="mit_description">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ 'map.sidebar.psa.bulk_risk_matrix.col_description' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let action">
                    <mat-form-field appearance="outline" class="inline-field wrap-field w-100">
                      <textarea matInput rows="2" [(ngModel)]="action.azione.descrizione" placeholder="Descrizione"
                        [matTooltip]="action.azione.descrizione" matTooltipShowDelay="400" matTooltipPosition="above"
                        [disabled]="isEventLocked(event)"></textarea>
                    </mat-form-field>
                  </td>
                </ng-container>

                <!-- Efficacia (riduzione_probabilita) -->
                <ng-container matColumnDef="mit_efficacy">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ 'map.sidebar.psa.bulk_risk_matrix.col_efficacy' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let action">
                    <mat-form-field appearance="outline" class="inline-field mit-progress-field">
                      <input matInput [(ngModel)]="action.riduzione_probabilita" type="number" min="0" max="100"
                        placeholder="0" [disabled]="isEventLocked(event)">
                    </mat-form-field>
                  </td>
                </ng-container>

                <!-- Responsabile -->
                <ng-container matColumnDef="mit_responsible">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ 'map.sidebar.psa.bulk_risk_matrix.col_responsible' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let action">
                    <mat-form-field appearance="outline" class="inline-field mit-responsible-field">
                      <input matInput [(ngModel)]="action.responsabile" placeholder="Responsabile"
                        [disabled]="isEventLocked(event)">
                    </mat-form-field>
                  </td>
                </ng-container>

                <!-- Pianificazione -->
                <ng-container matColumnDef="mit_planning">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ 'map.sidebar.psa.bulk_risk_matrix.col_planning' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let action">
                    <mat-form-field appearance="outline" class="inline-field mit-planning-field">
                      <input matInput [(ngModel)]="action.pianificazione"
                        (ngModelChange)="onPlanningChange(pianificazioneField, planningTooltip)"
                        #pianificazioneField="ngModel" [errorStateMatcher]="matcher"
                        pattern="^(Q[1-4] \d{4}|(0[1-9]|1[0-2])\/\d{4})$" placeholder="Q1 2024"
                        matTooltip="Attenzione: è preferibile utilizzare il formato standard &quot;Q1 2024&quot; oppure &quot;MM/YYYY&quot;"
                        matTooltipPosition="above" matTooltipClass="planning-warning-tooltip"
                        #planningTooltip="matTooltip" [matTooltipDisabled]="!pianificazioneField.invalid"
                        [disabled]="isEventLocked(event)">
                    </mat-form-field>
                  </td>
                </ng-container>

                <!-- Avanzamento -->
                <ng-container matColumnDef="mit_progress">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ 'map.sidebar.psa.bulk_risk_matrix.col_progress' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let action">
                    <mat-form-field appearance="outline" class="inline-field mit-progress-field">
                      <input matInput [(ngModel)]="action.avanzamento" type="number" min="0" max="100" placeholder="0"
                        [disabled]="isEventLocked(event)">
                    </mat-form-field>
                  </td>
                </ng-container>

                <!-- Costi -->
                <ng-container matColumnDef="mit_cost">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ 'map.sidebar.psa.bulk_risk_matrix.col_cost' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let action">
                    <mat-form-field appearance="outline" class="inline-field mit-cost-field">
                      <input matInput [(ngModel)]="action.costi" type="number" min="0" step="0.01" placeholder="€"
                        [disabled]="isEventLocked(event)">
                    </mat-form-field>
                  </td>
                </ng-container>

                <!-- Validazione -->
                <ng-container matColumnDef="mit_validation">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ 'map.sidebar.psa.bulk_risk_matrix.col_validation' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let action">
                    <mat-form-field appearance="outline" class="inline-field mit-validation-field">
                      <input matInput [(ngModel)]="action.validazione" placeholder="Validazione"
                        [disabled]="isEventLocked(event)">
                    </mat-form-field>
                  </td>
                </ng-container>

                <!-- Elimina azione -->
                <ng-container matColumnDef="mit_actions">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let action">
                    <button mat-icon-button color="warn" [disabled]="isEventLocked(event)"
                      (click)="deleteMitigationAction(event, action)"
                      [matTooltip]="(isEventLocked(event) ? 'map.sidebar.psa.risk_event.cannot_do_on_worked_event' : 'map.sidebar.psa.bulk_risk_matrix.tooltip_delete_action') | translate">
                      <mat-icon>delete_outline</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="mitigationColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: mitigationColumns;" class="mit-row">
                </tr>

              </table>
            </div>
            </ng-container>

          </div>
        </td>
      </ng-container>

      <!-- ================= ROW DEFINITIONS ================= -->

      <!-- Header principale -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="main-header-row">
      </tr>

      <!-- Header filtri -->
      <tr mat-header-row *matHeaderRowDef="filterColumns; sticky: true" class="filter-header-row">
      </tr>

      <!-- Riga evento -->
      <tr mat-row *matRowDef="let event; columns: displayedColumns;" class="event-row"
        [class.event-row-expanded]="isExpanded(event)" [class.event-row-active]="event.attivo"
        (click)="toggleExpand(event)">
      </tr>

      <!-- Detail row -->
      <tr mat-row *matRowDef="let event; columns: detailColumns;" class="detail-row">
      </tr>

      <!-- Nessun risultato -->
      <tr class="no-data-row" *matNoDataRow>
        <td class="empty-state text-center py-5" [attr.colspan]="displayedColumns.length">
          <mat-icon class="empty-icon">event_busy</mat-icon>
          <p class="empty-label mt-2">
            {{ 'map.sidebar.psa.bulk_risk_matrix.no_events' | translate }}
          </p>
        </td>
      </tr>

    </table>
  </div>

</div>

<!-- FOOTER -->
<div class="modal-footer d-flex justify-content-end align-items-center gap-3">
  <button mat-button (click)="onClose()">
    <mat-icon>close</mat-icon>
    {{ 'map.sidebar.psa.risk_event.button_cancel' | translate }}
  </button>
  <button mat-raised-button color="primary" [disabled]="isLoading || !isDirty || hasIncompleteRows || hasInvalidValues" (click)="onSave()">
    <mat-icon>save</mat-icon>
    {{ 'map.sidebar.psa.risk_event.button_save' | translate }}
  </button>
</div>